export default __webpack_public_path__ + "static/media/SYNTHETIC TRADING.7bc73340.svg";